(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["static-fit-guide"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function (event) {
    var navItems = document.querySelectorAll('.fit-guide__menu li a');

    navItems.forEach(function (item) {
      item.addEventListener('click', function () {
        var ihref = item.getAttribute('href');
        document.querySelector(`[id="${ihref}"]`).scrollIntoView({
          behavior: 'smooth',
        });
      });
    });

    /* Mobile nav */
    var mobileNav = document.querySelector('#frame-options');
    mobileNav.onchange = function () {
      var selectedOption = this.value;
      if (selectedOption != -0) {
        var fitGuides = document.querySelectorAll('.fit-guide__guide');
        var fitGuideActive = document.querySelector('.fit-guide__guide.active');
        var selectElement = document.querySelector(`[id="#${selectedOption}"]`);

        fitGuideActive.classList.remove('active');
        selectElement.classList.add('active');
        window.location.hash = selectedOption;
      }
    };
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["static-page-sections"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const hoursContainers = document.querySelectorAll('.hours-container');
    
    hoursContainers.forEach(container => {
      const hoursSourceData = container.querySelector('.hours-source-data');
      const hoursContent = container.querySelector('.hours-content');
      
      if (hoursSourceData && hoursContent) {
        const currentPageHandle = hoursSourceData.getAttribute('data-current-page');
        
        // Parse all tables from the hidden source data
        const tables = hoursSourceData.querySelectorAll('table');
        let matchedTable = null;
        
        // Extract shop identifier from current page URL
        // "pacific-beach-flagship-store" -> "pacific-beach"
        // "encinitas-store" -> "encinitas"
        // same for "houston" and "delray"
        let shopIdentifier = '';
        if (currentPageHandle.includes('pacific-beach')) {
          shopIdentifier = 'pacific-beach';
        } else if (currentPageHandle.includes('encinitas')) {
          shopIdentifier = 'encinitas';
        } else if (currentPageHandle.includes('houston')) {
          shopIdentifier = 'houston';
        } else if (currentPageHandle.includes('delray')) {
          shopIdentifier = 'delray';
        } else if (currentPageHandle.includes('austin')) {
          shopIdentifier = 'austin';
        }
        
        tables.forEach(table => {
          const rows = table.querySelectorAll('tr');
          if (rows.length > 0) {
            const firstCell = rows[0].querySelector('td');
            if (firstCell) {
              const tableName = firstCell.textContent.trim().toLowerCase().replace(/\s+/g, '-');
              
              // Check if the shop identifier matches the table name
              if (shopIdentifier && tableName.includes(shopIdentifier)) {
                matchedTable = table;
              }
            }
          }
        });
        
        // Append only the matched content to the hours-content div
        if (matchedTable) {
          // Show only the matched table
          const hoursRow = matchedTable.querySelectorAll('tr')[1];
          if (hoursRow) {
            const hoursCell = hoursRow.querySelector('td');
            if (hoursCell) {
              const hoursDiv = document.createElement('div');
              hoursDiv.className = 'store-hours';
              hoursDiv.innerHTML = hoursCell.innerHTML;
              hoursContent.appendChild(hoursDiv);
            }
          }
        } else {
          // Show all hours if no specific match
          tables.forEach(table => {
            const rows = table.querySelectorAll('tr');
            if (rows.length > 1) {
              const shopNameCell = rows[0].querySelector('td');
              const hoursCell = rows[1].querySelector('td');
              
              if (shopNameCell && hoursCell) {
                const storeDiv = document.createElement('div');
                storeDiv.className = 'store-hours-item';
                storeDiv.innerHTML = `
                  <h4 class="store-name">${shopNameCell.textContent.trim()}</h4>
                  <div class="hours-info">${hoursCell.innerHTML}</div>
                `;
                hoursContent.appendChild(storeDiv);
              }
            }
          });
        }
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
